import { render, staticRenderFns } from "./footerCopyright.vue?vue&type=template&id=3c3a6c64&scoped=true&"
import script from "./footerCopyright.vue?vue&type=script&lang=js&"
export * from "./footerCopyright.vue?vue&type=script&lang=js&"
import style0 from "./footerCopyright.vue?vue&type=style&index=0&id=3c3a6c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a6c64",
  null
  
)

export default component.exports